import React, { Component, PropTypes } from 'react';
import css from './spinner.scss';

export default class Spinner extends Component {
	static propTypes = {
		size: PropTypes.string,
		className: PropTypes.string,
		pathbgStroke: PropTypes.string,
		pathStroke: PropTypes.string,
		active: PropTypes.bool,
	};

	static defaultProps = {
		size: '20px',
		className: '',
		pathbgStroke: '#dbdbdb',
		pathStroke: '#666',
		active: true,
	};

	constructor(props) {
		super(props);
	}

	render() {
		let className = 'svg-spinner ' + this.props.className;

		if (!this.props.active) {
			className += ' svg-spinner--inactive';
		}

		return (
			<svg className={className} width={this.props.size} height={this.props.size} viewBox='0 0 66 66' xml='http://www.w3.org/2000/svg' xmlXlink='http://www.w3.org/1999/xlink'>
				<circle className='svg-spinner__path-bg' stroke={this.props.pathbgStroke} fill='none' strokeWidth='6' strokeLinecap='round' cx='33' cy='33' r='30'></circle>
				<circle className='svg-spinner__path' stroke={this.props.pathStroke} fill='none' strokeWidth='6' strokeLinecap='round' cx='33' cy='33' r='30'></circle>
			</svg>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/svg/spinner.js
 **/